import { SharedModule } from '$shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MainMenuComponent } from './main-menu.component';

@NgModule({
  declarations: [MainMenuComponent],
  imports: [CommonModule, SharedModule],
  exports: [MainMenuComponent],
})
export class MainMenuModule {}
